/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EditPurchaseMissionPayloadModel model module.
 * @module model/EditPurchaseMissionPayloadModel
 * @version v1.0.0
 */
class EditPurchaseMissionPayloadModel {
    /**
     * Constructs a new <code>EditPurchaseMissionPayloadModel</code>.
     * @alias module:model/EditPurchaseMissionPayloadModel
     */
    constructor() { 
        
        EditPurchaseMissionPayloadModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EditPurchaseMissionPayloadModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EditPurchaseMissionPayloadModel} obj Optional instance to populate.
     * @return {module:model/EditPurchaseMissionPayloadModel} The populated <code>EditPurchaseMissionPayloadModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EditPurchaseMissionPayloadModel();

            if (data.hasOwnProperty('bookListIds')) {
                obj['bookListIds'] = ApiClient.convertToType(data['bookListIds'], ['Number']);
            }
            if (data.hasOwnProperty('customerId')) {
                obj['customerId'] = ApiClient.convertToType(data['customerId'], 'Number');
            }
            if (data.hasOwnProperty('markUp')) {
                obj['markUp'] = ApiClient.convertToType(data['markUp'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<Number>} bookListIds
 */
EditPurchaseMissionPayloadModel.prototype['bookListIds'] = undefined;

/**
 * @member {Number} customerId
 */
EditPurchaseMissionPayloadModel.prototype['customerId'] = undefined;

/**
 * @member {Number} markUp
 */
EditPurchaseMissionPayloadModel.prototype['markUp'] = undefined;

/**
 * @member {module:model/EditPurchaseMissionPayloadModel.StatusEnum} status
 */
EditPurchaseMissionPayloadModel.prototype['status'] = undefined;

/**
 * @member {String} title
 */
EditPurchaseMissionPayloadModel.prototype['title'] = undefined;





/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */
EditPurchaseMissionPayloadModel['StatusEnum'] = {

    /**
     * value: "Confirm"
     * @const
     */
    "Confirm": "Confirm",

    /**
     * value: "Draft"
     * @const
     */
    "Draft": "Draft",

    /**
     * value: "Finish"
     * @const
     */
    "Finish": "Finish",

    /**
     * value: "Published"
     * @const
     */
    "Published": "Published",

    /**
     * value: "Sent"
     * @const
     */
    "Sent": "Sent"
};



export default EditPurchaseMissionPayloadModel;

